var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.pathList),function(path,index){return _c('router-link',{key:index,staticClass:"path",attrs:{"to":path.fullPath}},[_vm._v("\n        "+_vm._s(path.name)+" \n        "),(index !== _vm.pathList.length - 1)?_c('span',[_vm._v("/ ")]):_vm._e()])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }